// extracted by mini-css-extract-plugin
module.exports = {"mediaLightbox":"ImageLightbox_mediaLightbox__2PNXc","downloadLink":"ImageLightbox_downloadLink__y-ov6"};